import { useLocation, useMatch } from 'react-router'
import { AppNav } from '@/components/layout/side-nav/app-nav'
import { DatabaseNav } from '@/components/layout/side-nav/database-nav'
import { LoadBalancerNav } from '@/components/layout/side-nav/load-balancer-nav'
import { ObjectStorageNav } from '@/components/layout/side-nav/object-storage-nav'
import { ProjectNav } from '@/components/layout/side-nav/project-nav'
import { StaticSiteNav } from '@/components/layout/side-nav/static-site-nav'
import { WebhookNav } from '@/components/layout/side-nav/webhook-nav'

export type ResourceContext = {
  type: string
  name: string
  node: React.ReactNode
} | null

export const useResourceContext = (): ResourceContext => {
  const location = useLocation()
  const appMatch = useMatch('/app/:appName/*')
  const databaseMatch = useMatch('/database/:databaseName/*')
  const staticSiteMatch = useMatch('/static-site/:staticSiteName/*')
  const loadBalancerMatch = useMatch('/load-balancer/:loadBalancerName/*')
  const webhookMatch = useMatch('/webhook/:idWebhook/*')
  const objectStorageMatch = useMatch('/object-storage/:idObjectStorage/*')
  const projectMatch = useMatch('/project/:projectName/*')

  const isAppPage =
    Boolean(appMatch) && !location.pathname.includes('/apps/create')
  const isObjectStoragePage =
    Boolean(objectStorageMatch) &&
    location.pathname !== '/object-storage/create'

  if (isAppPage && appMatch) {
    return {
      type: 'Application',
      name: appMatch.params.appName ?? '',
      node: <AppNav />,
    }
  }
  if (databaseMatch) {
    return {
      type: 'Database',
      name: databaseMatch.params.databaseName ?? '',
      node: <DatabaseNav />,
    }
  }
  if (staticSiteMatch) {
    return {
      type: 'Static site',
      name: staticSiteMatch.params.staticSiteName ?? '',
      node: <StaticSiteNav />,
    }
  }
  if (loadBalancerMatch) {
    return {
      type: 'Load balancer',
      name: loadBalancerMatch.params.loadBalancerName ?? '',
      node: <LoadBalancerNav />,
    }
  }
  if (projectMatch) {
    return {
      type: 'Project',
      name: projectMatch.params.projectName ?? '',
      node: <ProjectNav />,
    }
  }
  if (webhookMatch) {
    return {
      type: 'Webhook',
      name: webhookMatch.params.idWebhook ?? '',
      node: <WebhookNav />,
    }
  }
  if (isObjectStoragePage && objectStorageMatch) {
    return {
      type: 'Object storage',
      name: objectStorageMatch.params.idObjectStorage ?? '',
      node: <ObjectStorageNav />,
    }
  }
  return null
}
